import { TableCell, TableHead } from "@mui/material";
import React from "react";
import { Checkbox } from "../../../Checkbox/Checkbox";
import ColumnResizer from "../ColumnResizer";
import HeaderCell from "../HeaderCell";
import { dataGridStyles } from "./DataGridStyles";
export default function FixedHeader(props) {
    const { allowSelection, fixedColumnCount, fixedHeadersRef, getColumnWidth, getToggleAllRowsSelectedProps, headerGroups } = props;
    return (React.createElement(TableHead, { component: "div", ref: fixedHeadersRef, sx: dataGridStyles.fixedHeader, role: "rowheader" },
        allowSelection ? React.createElement(Checkbox, { ...getToggleAllRowsSelectedProps(), indeterminate: false, "aria-label": "" }) : null,
        headerGroups[0].headers.slice(0, fixedColumnCount).map((column) => {
            return (React.createElement("div", { className: "data-grid-column-header", key: column.id, role: "columnheader", style: {
                    display: "flex",
                    width: getColumnWidth(column.id) ?? column.pxWidth ?? column.width,
                    maxWidth: column.maxWidth,
                    minWidth: column.minWidth,
                    ...(column.flexGrow && { flexGrow: column.flexGrow, flexShrink: 0 }),
                    ...(!(column.flexGrow || column.pxWidth) && { flexGrow: 1, flexShrink: 0 })
                } },
                React.createElement(TableCell, { className: "data-grid-column-header-cell", component: "div", ...column.getHeaderProps({
                        ...column.getSortByToggleProps(),
                        style: {
                            display: "flex",
                            width: "100%",
                            justifyContent: column.align == "left" ? "flex-start" : column.align == "right" ? "flex-end" : column.align,
                            flex: "",
                            minWidth: undefined,
                            userSelect: "none",
                            alignItems: "center"
                        }
                    }), role: "cell" },
                    React.createElement(HeaderCell, { ...column })),
                React.createElement(ColumnResizer, { column: column })));
        })));
}
